'use client'

import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'

import FlagArabia from '~/assets/icons/Flag_Arabia-Saudita.png'
import FlagBrasil from '~/assets/icons/Flag_Brasil.png'
import FlagChina from '~/assets/icons/Flag_China.png'
import FlagEspanha from '~/assets/icons/Flag_Espanha.png'
import FlagEUA from '~/assets/icons/Flag_EUA.png'

import ModalGetBraza from '../center-modal/center-modal-getbraza'
import LanguageFlag from './language-flag'

const PopupGetBraza: React.FC = () => {
  const [isOpen, setIsOpen] = useState(true)
  const pathname = usePathname()
  const [modalTitle, setModalTitle] = useState('Escolha seu idioma')

  useEffect(() => {
    switch (pathname) {
      case '/getbraza/':
        setModalTitle('Escolha seu idioma')
        break
      case '/getbraza/es/':
        setModalTitle('Elige tu idioma')
        break
      case '/getbraza/en/':
        setModalTitle('Choose your language')
        break
      case '/getbraza/zh/':
        setModalTitle('选择您的语言')
        break
      case '/getbraza/AR/':
        setModalTitle('اختر لغتك')
        break
      default:
        setModalTitle('Escolha seu idioma')
    }
  }, [pathname])

  return (
    <ModalGetBraza isActive={isOpen} onClose={() => setIsOpen(false)}>
      <div className="pt-20 pb-6 px-4 flex justify-center max-h-[40vh] overflow-y-auto sm:px-8 sm:pt-24 sm:pb-10">
        <div className="w-full max-w-[27.5rem] flex flex-col gap-8 lg:gap-6">
          <h2 className="text-3xl sm:text-5xl text-center mb-8 sm:mb-6">
            {modalTitle}
          </h2>
          <div className="flex justify-center gap-2 sm:gap-4 flex-wrap">
            <LanguageFlag
              src={FlagBrasil}
              href="/getbraza"
              label="PORTUGUÊS"
              onClick={() => setIsOpen(false)}
            />
            <LanguageFlag
              src={FlagEspanha}
              href="/getbraza/es"
              label="ESPAÑOL"
              onClick={() => setIsOpen(false)}
            />
            <LanguageFlag
              src={FlagEUA}
              href="/getbraza/en"
              label="ENGLISH"
              onClick={() => setIsOpen(false)}
            />
            <LanguageFlag
              src={FlagChina}
              href="/getbraza/zh"
              label="國語"
              onClick={() => setIsOpen(false)}
            />
            <LanguageFlag
              src={FlagArabia}
              href="/getbraza/AR"
              label="عربي"
              onClick={() => setIsOpen(false)}
            />
          </div>
        </div>
      </div>
    </ModalGetBraza>
  )
}

export default PopupGetBraza
